export default __webpack_public_path__ + "static/media/checkmark.452af112.svg";